const { User2Icon } = require("lucide-react");

//  ✅ COLORS
//const avatarColors = ["#F87171","#FB923C","#FBBF24","#FACC15","#F472B6","#E879F9","#EF4444","#DC2626","#BE123C","#EC4899","#DB2777","#FB923C","#FBBF24","#FACC15","#F97316","#EA580C","#CA8A04","#EAB308","#FEF08A","#A3E635","#4ADE80","#34D399","#22C55E","#16A34A","#15803D","#86EFAC","#2DD4BF","#14B8A6","#0D9488","#5EEAD4","#38BDF8","#60A5FA","#3B82F6","#2563EB","#1D4ED8","#818CF8","#6366F1","#4F46E5","#7C3AED","#8B5CF6","#64748B","#FF6B6B","#FFD93D","#6BCB77","#4D96FF","#843B62","#E36414","#0B5ED7","#2EC4B6","#F15BB5"];
const avatarColors = [
  "#FDE2E4", // soft pink
  "#F9E2AF", // light gold
  "#E3F2C1", // light green
  "#CFF5E7", // mint
  "#CAF0F8", // baby blue
  "#DEE2FF", // lavender
  "#EDE7F6", // soft purple
  "#FFEDD5", // soft peach
  "#FFE5D9", // warm blush
  "#FFF4E6", // cream
  "#E8F3D6", // pale green
  "#D6EAF8", // sky pastel blue
  "#F3E8FF", // lilac pastel
  "#FDE7F3", // rose pastel
  "#E5F4FD", // ice blue
  "#E7F6EC", // fresh pastel green
  "#FFF1F2", // pastel pink/tint
  "#F2FCE8", // lime cream
  "#FDF2FA", // pink mist
  "#FFF7ED"  // peach milk
];

 //  ✅ UTILS
const getInitials = (name = "") => {
  if (!name) return "";

  const parts = name.trim().split(/\s+/);

  if (parts.length >= 3) {
    // First + Last only
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }

  if (parts.length === 2) {
    // First + Last
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  // Only First Name
  return parts[0][0].toUpperCase();
};

const getColorFromInitials = (initials) => {
  if (!initials) return avatarColors[0];

  const charCodeSum = initials.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);

  return avatarColors[charCodeSum % avatarColors.length];
};

function getContrastColor(hexColor) {
  const c = hexColor.substring(1); // remove #
  const rgb = parseInt(c, 16);     
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;

  // calculate relative luminance
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // pastel is light → use dark text
  return luminance > 180 ? "#333" : "#fff";
}
  //  ✅ USER AVATAR (UPDATED TO USE `name`)
const UserAvatar = ({
  name = "",
  imageUrl = "",
  className,
  size = 40,
}) => {
  const initials = getInitials(name);
  //const bgColor = getColorFromInitials("pl");
  const bgColor = getColorFromInitials(initials);
  const textColor = getContrastColor(bgColor);
  const fullName = name?.trim();

  const showImage = Boolean(imageUrl);
  const showInitials = !showImage && Boolean(initials);
  const showIcon = !showImage && !initials;

  return (
    <div className={className || "relative group"}>
      {/* ✅ IMAGE */}
      {showImage && (
        <img
          src={imageUrl}
          alt={fullName || "User"}
          className="rounded-full object-cover"
          style={{ width: size, height: size }}
        />
      )}

      {/* ✅ INITIALS */}
      {showInitials && (
        <div
            className="rounded-full flex items-center justify-center font-normal select-none uppercase"
            style={{
            width: size,
            height: size,
            backgroundColor: bgColor,
            color: textColor
            }}
        >
            {initials}
        </div>
        )}

      {/* ✅ USER ICON */}
      {showIcon && (
        <div
          className="rounded-full flex items-center justify-center bg-slate-200"
          style={{ width: size, height: size }}
        >
          <User2Icon
            className="text-white"
            style={{ width: size * 0.45, height: size * 0.45 }}
          />
        </div>
      )}

      {/* ✅ HOVER FULL NAME */}
      {fullName && (
        <div
          className="absolute right-0 mt-2 hidden group-hover:block bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap shadow-lg z-50"
        >
          {fullName}
        </div>
      )}
    </div>
  );
};
export default UserAvatar;